import {fetchWrapper} from "../../helpers/fetch.wrapper";

const baseUrl = process.env.REACT_APP_BASE_URL;
export const authService = {
    login,
    registration,
    resetPassword,
    checkToken,
    changePassword,
    updateProfile,
    lookUpAccount,
    updateWynshopLoyaltyId,
    deleteCustomerRecord,
    sendEmailVerifyLink
}

async function login(loginDetail) {
    return fetchWrapper.post(`${baseUrl}/customer/authenticate`,
        loginDetail)
        .then(response => {
            return response;
        });
}

async function registration(registrationDetails) {

    return fetchWrapper.post(`${baseUrl}/customer/registration`,
        registrationDetails)
        .then(response => {
            return response;
        });
}

async function lookUpAccount(lookUpData) {

    return fetchWrapper.get(`${baseUrl}/admin/member/lookup/details?fieldType=${encodeURIComponent(lookUpData.fieldType)}&searchValue=${encodeURIComponent(lookUpData.searchValue)}`)
        .then(response => {
            return response;
        });
}

async function deleteCustomerRecord(email) {

    return fetchWrapper.post(`${baseUrl}/admin/delete/profile/${email}`, {})
        .then(response => {
            return response;
        });
}

async function updateWynshopLoyaltyId(customerId) {

    return fetchWrapper.post(`${baseUrl}/admin/wynshop/fix/loyalty-id/${customerId}`, {})
        .then(response => {
            return response;
        });
}

async function updateProfile(updateDetails) {

    return fetchWrapper.post(`${baseUrl}/admin/customer/update`, updateDetails)
        .then(response => {
            return response;
        });
}


async function resetPassword(userId) {
    return fetchWrapper.post(
        `${baseUrl}/admin/reset-password`, {userId}
    ).then(response => {
        return response;
    });
}


async function sendEmailVerifyLink(userId) {
    return fetchWrapper.post(
        `${baseUrl}/admin/email-verification-link?userId=${encodeURIComponent(userId)}`
    ).then(response => {
        return response;
    });
}

async function checkToken() {

    return fetchWrapper.post(`${baseUrl}/customer/check-token`)
        .then(response => {
            return response;
        });
}

async function changePassword(changePassword) {

    return fetchWrapper.post(`${baseUrl}/customer/change-password`,
        changePassword)
        .then(response => {
            return response;
        });
}
